import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TABS_CONFIG } from '../../constants';

const ViewToggle = () => (
  <TabsList>
    {TABS_CONFIG.map(({ icon, label, value }) => (
      <TabsTrigger key={value} value={value}>
        <FontAwesomeIcon icon={icon} />
        <span>{label}</span>
      </TabsTrigger>
    ))}
  </TabsList>
);

export default ViewToggle;
